import { useContext, useEffect, useState } from "react";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import Style from "./style.module.css";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import "react-datepicker/dist/react-datepicker.css";
import { Bell, Handshake, XIcon } from "lucide-react";
import { GlobalContext } from "../../../../context/Context";
import { Alert, Snackbar } from "@mui/material";
import AddLeadModal from "../../../../component/modals/add-update/add-update-lead";
import EditDealModal from "../../../../component/modals/add-edit-modal/EditDealModal";
import AddActivityModal from "../../../mainActivities/activities/activity/add-update/add-update-activity";

const EmployeeDirectoryAddUpdate = ({
  open = null,
  onClose = () => {},
  data = {},
  onChange = () => {},
  tabIndex = 0,
  onError = () => {},
  onSubmit = () => {},
  id = "",
  entitytype = "",
  entityname = "",
  contactId,
  onDealUpdated = () => {}, // refresh after update,
  type = "",
  statusList = [],
  fromInnerPage = false,
}) => {
  const apiCall = useApiCall();

  let { state, dispatch } = useContext(GlobalContext);

  const [navIndex, setNavIndex] = useState(tabIndex || 0);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [DealStages, setDealStages] = useState([]); // lead / deal
  const [usersList, setUsers] = useState([]); // using all modal

  // const [country, setCountry] = useState([]); // use only lead ///
  // const [brands, setBrands] = useState([]); // use only lead ///
  // const [entityData, setEntityData] = useState([]); // use in follow ups

  /////============== use only in deal =================//////////////////

  // const [hasMoreClients, setHasMoreClients] = useState(true);
  // const [isLoadingClients, setIsLoadingClients] = useState(false);
  // const [Clients, setClients] = useState([]); // use only in deal
  // const [page, setPage] = useState(1);

  // const Countries = async () => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `location/get-countries`,
  //     });
  //     setCountry(res?.data);
  //   } catch (error) {
  //     console.warn("Error : ", error);
  //   }
  // };

  // const getBrands = async () => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: "brands/brands-list?is_paginate=0",
  //     });

  //     setBrands(res?.data || []);
  //   } catch (error) {
  //     console.warn("Error fetching brands:", error);
  //   }
  // };

  /////// Entities

  // const fetchEntities = async (search = "") => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `activities/get-activity-type?search=${encodeURIComponent(
  //         search,
  //       )}`,
  //     });

  //     const list = res?.data || []; // 👈 safe access to data array

  //     setEntityData(
  //       list.map((item) => ({
  //         id: item.id,
  //         name: item.name,
  //         type: item.type,
  //       })),
  //     );
  //   } catch (error) {
  //     console.error("Error fetching entities:", error);
  //   }
  // };

  // load Clients

  // const loadClients = async (pageNum = 1, search = "") => {
  //   // agar search active hai to hamesha page 1 hi chalega
  //   if (search && pageNum > 1) return;

  //   if (isLoadingClients || (!hasMoreClients && pageNum !== 1)) return;

  //   if (pageNum === 1) {
  //     setHasMoreClients(true);
  //     setPage(1);
  //   }

  //   setIsLoadingClients(true);

  //   try {
  //     const url = search
  //       ? `users/customers-list?search=${encodeURIComponent(search)}`
  //       : `users/customers-list?page=${pageNum}`;

  //     const res = await apiCall({ method: "get", url });
  //     const newClients = res?.customers || [];

  //     if (pageNum === 1) {
  //       setClients(newClients);
  //     } else if (newClients.length === 0) {
  //       setHasMoreClients(false);
  //     } else {
  //       setClients((prev) => [...prev, ...newClients]);
  //     }

  //     setPage(pageNum);
  //   } catch (err) {
  //     console.error("Error fetching users", err);
  //   } finally {
  //     setIsLoadingClients(false);
  //   }
  // };

  const fetchUsers = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsers(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
    }
  };
  const DealStage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });

      // filter out "Won" and "Lost"
      const filteredStages = res.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost",
      );

      setDealStages(filteredStages);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    if (tabIndex != 2) {
      DealStage();
    }
    fetchUsers();
    // Countries();
    // getBrands();
    // fetchEntities();
    // loadClients();
  }, []);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  return (
    <div className={Style.modal_body}>
      {/* popupStatus */}
      <LeftSidePopupLayout
        popupStatus={true}
        className={Style.departmentChangeModal}
      >
        <div className={Style.modal_header}>
          <div className={Style.modal_nav}>
            {fromInnerPage ? (
              <ul>
                <li
                  className={navIndex === 1 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(1);
                  }}
                >
                  <div className={Style.icon}>
                    <Handshake size={18} />
                  </div>
                  <span>{data?.dealid ? "Update" : "Add"} Deal</span>
                </li>
              </ul>
            ) : (
              <ul>
                {(data?.leadid ||
                  data?.userid ||
                  data?.id ||
                  data?.dealid ||
                  data?.client_id) &&
                navIndex !== 0 ? null : (
                  <li
                    className={navIndex === 0 ? Style.active : null}
                    onClick={() => {
                      setNavIndex(0);
                    }}
                  >
                    <div className={Style.icon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                    <span>
                      {data?.leadid || data?.userid ? "Update" : "Add"}{" "}
                      {data?.userid ? "Contact" : "Lead"}{" "}
                    </span>
                  </li>
                )}

                {(data?.leadid || data?.userid || data?.id || data?.dealid) &&
                navIndex !== 1 ? null : (
                  <li
                    className={navIndex === 1 ? Style.active : null}
                    onClick={() => {
                      setNavIndex(1);
                    }}
                  >
                    <div className={Style.icon}>
                      <Handshake size={18} />
                    </div>
                    <span>{data?.dealid ? "Update" : "Add"} Deal</span>
                  </li>
                )}

                {(data?.leadid || data?.userid || data?.id || data?.dealid) &&
                navIndex !== 2 ? null : (
                  <li
                    className={navIndex === 2 ? Style.active : null}
                    onClick={() => {
                      setNavIndex(2);
                    }}
                  >
                    <div className={Style.icon}>
                      <Bell size={18} />
                    </div>
                    <span>Follow ups</span>
                    {/* {(data?.leadid || data?.userid  || data?.id)? "Update" : "Create"}  */}
                  </li>
                )}
              </ul>
            )}
          </div>

          <div
            className={Style.close_btn}
            style={{
              position: "absolute",
              top: "-16px",
              right: "-16px",
            }}
            onClick={() => {
              onClose();
            }}
          >
            <XIcon size={"1em"} />
          </div>
        </div>

        {navIndex === 0 && (
          <AddLeadModal
            onClose={() => {
              onClose();
            }}
            onChange={() => {
              onChange();
            }}
            CustomerData={data}
            // BrandList={brands}
            DealStages={DealStages}
            // Countries={country}
            UsersList={usersList}
            statusList={statusList}
            Style={Style}
            onError={onError}
            onSubmit={onSubmit}
          />
        )}

        {navIndex === 1 && (
          <EditDealModal
            open={open}
            onClose={() => onClose()}
            dealData={data}
            DealStages={DealStages}
            UserList={usersList}
            contactId={contactId}
            onDealUpdated={onDealUpdated} // refresh after update
            onSubmit={onSubmit}
            onError={onError}
            // ClientList={Clients}
            // onLoadMoreClients={loadClients}
            // hasMoreClients={hasMoreClients}
            // page={page}
            // isLoadingClients={isLoadingClients}
            Style={Style}
            type={type}
          />
        )}

        {navIndex === 2 && (
          <AddActivityModal
            onSubmit={onSubmit}
            onClose={() => {
              onClose();
              // setEntityData([]);
            }}
            onError={onError}
            UsersList={usersList}
            CustomerData={data}
            // entityData={entityData}
            // onSearchEntity={fetchEntities}
            Style={Style}
            id={id}
            entitytype={entitytype}
            entityname={entityname}
          />
        )}
      </LeftSidePopupLayout>

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default EmployeeDirectoryAddUpdate;
